<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="currentColor" fill-rule="evenodd">
      <g
        transform="translate(-257 -2144) translate(0 704) translate(0 1328) translate(15 88) translate(242 24)"
      >
        <path
          stroke="#313132"
          stroke-width="1.25"
          d="M27.084 28.625c-4.282 0-8.24 1.39-11.448 3.742-3.238 2.376-5.71 5.733-6.98 9.633 1.27 3.901 3.743 7.258 6.98 9.633 3.208 2.353 7.166 3.742 11.448 3.742 4.283 0 8.241-1.39 11.448-3.742 3.238-2.376 5.711-5.733 6.98-9.633-1.269-3.901-3.742-7.258-6.98-9.633-3.207-2.353-7.165-3.742-11.448-3.742zm0-20c-2.036 0-3.88.825-5.215 2.16-1.334 1.335-2.16 3.178-2.16 5.215s.826 3.88 2.16 5.215c1.335 1.335 3.179 2.16 5.215 2.16 2.037 0 3.88-.825 5.215-2.16 1.335-1.335 2.16-3.178 2.16-5.215s-.825-3.88-2.16-5.215c-1.334-1.335-3.178-2.16-5.215-2.16zm26.416 0l-13.143.005c-.483.036-.914.256-1.226.589-.314.335-.506.786-.506 1.281l1.067 12.424 2.55-2.55 11.39.06c.483-.034.916-.251 1.23-.582.315-.334.51-.783.513-1.279l-.005-8.215c-.036-.483-.256-.915-.589-1.227-.335-.314-.786-.506-1.281-.506z"
        />
        <rect width="12" height="1" x="41" y="11" fill="#313132" rx=".5" />
        <rect width="6" height="1" x="41" y="17" fill="#313132" rx=".5" />
        <rect width="12" height="1" x="41" y="14" fill="#313132" rx=".5" />
        <path
          fill="#FF7F7C"
          d="M27 33c-2.76 0-5 2.223-5 4.965V49h3.612v-4.414h2.777V49H32V37.965C32 35.223 29.762 33 27 33zm-1.388 8.276v-3.31c0-.762.621-1.38 1.388-1.38.767 0 1.39.618 1.39 1.38v3.31h-2.778z"
        />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  name: 'IconConseilPedagogique'
})
</script>
